// extracted by mini-css-extract-plugin
export default {"xs":"Text_xs__IALYZ","sm":"Text_sm__gIWfr","md":"Text_md__dV9v2","lg":"Text_lg__XOKnT","xl":"Text_xl__T4y03","xxl":"Text_xxl__Imn53","xxxl":"Text_xxxl__Zp6mF"};